export default "Formgiv jeres egne små lerkrukker, der minder om den Ask bruger til at bære gløden i historien.\n\n**Denne aktivitet kan også laves hjemme.**";